import { createFilterStore } from 'shared/state/create-filter-store';

export type ShopCategoryFilter = {
  page: number;
  sortBy: string | null;
};

export const defaultShopCategoryFilter: ShopCategoryFilter = {
  page: 1,
  sortBy: null,
};

export const sortOptions = ['recommended', 'popular', 'cheap', 'expensive'];

export const [ShopCategoryFilterProvider, useShopCategoryFilterStore] =
  createFilterStore(defaultShopCategoryFilter);
